import PropertyCreateContainer from "./PropertyCreateContainer";
export default PropertyCreateContainer;
